import { FC, useEffect } from "react"
import { ReactComponent as TimeIcon } from "../../../icons/timeIcon.svg"
import "./style.scss"

interface ShowEstimationProps {
  coreFunctionalities: any
  estimationTimer: number
  setEstimationTimer: React.Dispatch<React.SetStateAction<number>>
  setTriggerTimer: React.Dispatch<React.SetStateAction<boolean>>
}

const ShowEstimation: FC<ShowEstimationProps> = ({ coreFunctionalities, estimationTimer, setEstimationTimer, setTriggerTimer }) => {

  function convertSecondsToHMS(seconds: number) {
    const hours = Math.floor(seconds / 3600); // Calculate hours
    const minutes = Math.floor((seconds % 3600) / 60); // Calculate minutes
    const secs = seconds % 60; // Calculate remaining seconds


    return `${hours.toString().padStart(2, '0')}h :${minutes
      .toString()
      .padStart(2, '0')}m :${secs.toString().padStart(2, '0')}s`;
  }

  useEffect(() => {
    if (!estimationTimer) {
      setEstimationTimer(coreFunctionalities?.length * 30)
      setTriggerTimer(true)
    }
  }, [])

  return (
    <div className="showEstimationContainer">
      <div className="inner-estimation-container">
        <div className="document-prepared-header message">
          Your document is being prepared
        </div>
        <div className="document-ready-message message">We will notify you once your document is ready</div>
        <TimeIcon />
        <div className="estimation-container message">Estimation: <span className="estimation-time">{convertSecondsToHMS(estimationTimer)}</span></div>
        <div className="estimation-container message">Feel free to close this page</div>
      </div>
    </div>
  )
}

export default ShowEstimation